import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import auth from "../../services/authService";
import Swal from "sweetalert2";
import { loadRolePermission, loadUserDetails } from "../../app/store/auth";

const RecruitmentHexagon = () => {
  const [currentUser, setCurrentUser] = useState("");
  const [user, setUser] = useState("");
  const [rolePermission, setRolePermission] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      const user = auth.getCurrentUser();
      const currentUser = await dispatch(loadUserDetails(user.id));
      if (!currentUser) return;
      setUser(user);
      setCurrentUser(currentUser);

      if (currentUser?.registrationType === "WP") {
        const permission = await dispatch(loadRolePermission(currentUser.roleId));
        if (permission !== "") {
          setRolePermission(permission);
        }
      }
    };

    fetchData();
  }, [dispatch]);

  const checkMenuPermission = (mid) => {
    if (user.type === "admin") return true;
    const mm = mid.split("_");
    let chk = false;
    if (mm[0] === "m") {
      const mR = rolePermission.filter(
        (x) => x.id === parseInt(mm[1]) && x.isChecked === true
      );
      if (mR.length > 0) {
        chk = true;
      } else {
        rolePermission
          .filter((x) => x.id === parseInt(mm[1]))
          .forEach((menu) => {
            const sMenu = menu.menus.filter((x) => x.isChecked === true);
            if (sMenu.length > 0) {
              chk = true;
            } else {
              menu.menus.forEach((ssmenu) => {
                if (ssmenu?.menus) {
                  const ssMenu = ssmenu.menus.filter(
                    (x) => x.isChecked === true
                  );
                  if (ssMenu.length > 0) {
                    chk = true;
                  }
                }
              });
            }
          });
      }
    }
    if (mm[0] === "sm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[2]))
        .forEach((menu) => {
          const sMenu = menu.menus.filter(
            (x) => x.id === parseInt(mm[1]) && x.isChecked === true
          );
          if (sMenu.length > 0) {
            chk = true;
          } else {
            menu.menus.forEach((smenu) => {
              if (smenu?.menus) {
                const ssMenu = smenu.menus.filter((x) => x.isChecked === true);
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (smenu?.isChecked) {
                  chk = true;
                }
              }
            });
          }
        });
    }
    if (mm[0] === "ssm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[3]))
        .forEach((menu) =>
          menu.menus
            .filter((x) => x.id === parseInt(mm[2]))
            .forEach((ssmenu) => {
              if (ssmenu?.menus) {
                const ssMenu = ssmenu.menus.filter(
                  (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                );
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (ssmenu?.isChecked) chk = true;
              }
            })
        );
    }
    return chk;
  };

  const permissionAlert = () => {
    Swal.fire("Your are not authorized", "", "error");
  };

  let loggedUser = { ...user };
  if (
    loggedUser.type !== "admin" &&
    currentUser.roleType === "Complete Application Ownership"
  ) {
    loggedUser.type = "admin";
  }

  return (
    <div id="content">
      {/* Modern category legend bar */}
      <div className="wf-hex-legend">
        <p className="wf-hex-legend-title">Platform Modules</p>
        <div className="wf-hex-legend-chips">
          <span className="wf-hex-chip wf-hex-chip-pre">
            <span className="wf-hex-chip-dot"></span>System Administration
          </span>
          <span className="wf-hex-chip wf-hex-chip-create">
            <span className="wf-hex-chip-dot"></span>Onboarding &amp; Contracts
          </span>
          <span className="wf-hex-chip wf-hex-chip-build">
            <span className="wf-hex-chip-dot"></span>Invoices
          </span>
          <span className="wf-hex-chip wf-hex-chip-test">
            <span className="wf-hex-chip-dot"></span>Analytics
          </span>
          <span className="wf-hex-chip wf-hex-chip-deploy">
            <span className="wf-hex-chip-dot"></span>Security
          </span>
          <span className="wf-hex-chip wf-hex-chip-monitor">
            <span className="wf-hex-chip-dot"></span>Communication
          </span>
        </div>
      </div>

      <div
        id="page"
        onClick={(e) => {
          const anchor = e.target.closest("a");
          if (anchor) {
            const href = anchor.getAttribute("href");
            if (href === "#access-denied") {
              e.preventDefault();
              alert("Access Denied");
            } else if (href === "#") {
              e.preventDefault();
            }
          }
        }}
      >
        <div id="data_wrapper">
          <div id="data">
            <div>
              <div className="item main r1 c2 even_row pre" rel="pre">
                <a href="#" aria-label="System Administration">&nbsp;</a>
              </div>
              <div className="item pre r2 c2">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_1")
                      ? "/WorkflowUser"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Users"
                      src="../../assets/HexagonDesign/cells/1_1.png"
                      title="Authorized Users"
                    />
                  </a>
                </div>
              </div>
              <div className="item pre r2 c3">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_3_2_1")
                      ? "/ListCondidate/partner"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Cd Entity"
                      src="../../assets/HexagonDesign/cells/entity_candidate.png"
                      title="Candidate Entity"
                    />
                  </a>
                </div>
              </div>
              <div className="item pre even_row r3 c2">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_2_1")
                      ? "/ListSubcontractor/partner"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Sb Entity"
                      src="../../assets/HexagonDesign/cells/enitity_subcontractor.png"
                      title="Subcontractor Entity"
                    />
                  </a>
                </div>
              </div>
              <div className="item pre r4 c3">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_2_1")
                      ? "/Recruiter/partner"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Rr Entity"
                      src="../../assets/HexagonDesign/cells/entity_recruiter.png"
                      title="Recruiter Entity"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="item main r1 c3 even_row create" rel="create">
                <a href="#" aria-label="Onboarding and Contracts">&nbsp;</a>
              </div>
              <div className="item create r2 c4">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_3_3_2")
                      ? "/ListCondidate/application"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Candidate list"
                      src="../../assets/HexagonDesign/cells/2_3.png"
                      title="List of Candidate"
                    />
                  </a>
                </div>
              </div>
              <div className="item create even_row r3 c3">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_2")
                      ? "/ListSubcontractor/application"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="List of Subcontractor"
                      src="../../assets/HexagonDesign/cells/2_1.png"
                      title="Subcontractor list"
                    />
                  </a>
                </div>
              </div>
              <div className="item create r4 c4">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_2_2")
                      ? "/Recruiter/application"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="List of recruiter"
                      src="../../assets/HexagonDesign/cells/2_2.png"
                      title="Recruiter list"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="item main r1 c4 even_row build" rel="build">
                <a href="#" aria-label="Invoices">&nbsp;</a>
              </div>
              <div className="item build r2 c5">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_3")
                      ? "/ListCondidate/timelog"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Time Log Management"
                      src="../../assets/HexagonDesign/cells/3_1.png"
                      title="TL Management"
                    />
                  </a>
                </div>
              </div>
              <div className="item build even_row r3 c4">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_2_3")
                      ? "/ListCondidate/invoice"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Invoices and Payments"
                      src="../../assets/HexagonDesign/cells/3_2.png"
                      title="Inv and Payments"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="item main r1 c5 even_row test" rel="test">
                <a href="#" aria-label="Analytics">&nbsp;</a>
              </div>
              <div className="item test r2 c6">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_4")
                      ? "/Dashboard"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Dashboard"
                      src="../../assets/HexagonDesign/cells/4_1.png"
                      title="D board"
                    />
                  </a>
                </div>
              </div>
              <div className="item test even_row r3 c5">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_2_4")
                      ? "/ApplicationReport"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Et Data"
                      src="../../assets/HexagonDesign/cells/4_2.png"
                      title="Entity Data"
                    />
                  </a>
                </div>
              </div>
              <div className="item test even_row r3 c6">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_3_3_4")
                      ? "/CustomReport/report"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Bns Reports"
                      src="../../assets/HexagonDesign/cells/4_3.png"
                      title="Business Reports"
                    />
                  </a>
                </div>
              </div>
              <div className="item test r4 c5">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_5_5_4")
                      ? "/CustomReport/compliance"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Reports / Docs"
                      src="../../assets/HexagonDesign/cells/4_5.png"
                      title="Compliance Reports / Docs"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="item main r1 c6 even_row deploy" rel="deploy">
                <a href="#" aria-label="Security">&nbsp;</a>
              </div>
              <div className="item deploy r2 c7">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_5")
                      ? "/MonitoringLogs"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Monitor Logs"
                      src="../../assets/HexagonDesign/cells/5_1.png"
                      title="Monitoring Logs"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="item main r1 c7 even_row monitor" rel="monitor">
                <a href="#" aria-label="Communication">&nbsp;</a>
              </div>
              <div className="item monitor r2 c8">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_3_1_6")
                      ? "/ApplicantEmails/mail"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Can Mail"
                      src="../../assets/HexagonDesign/cells/candidate_email.png"
                      title="Candidates Mail"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor even_row r3 c7">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_1_6")
                      ? "PartnerEmails/mail"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Sub Mail"
                      src="../../assets/HexagonDesign/cells/sub_email.png"
                      title="Subcontractors Mail"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor r4 c7">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_1_6")
                      ? "/AgencyEmails/mail"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Rec Mail"
                      src="../../assets/HexagonDesign/cells/rec_emails.png"
                      title="Recruiters Mail"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor even_row r3 c8">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_3_2_6")
                      ? "/ApplicantEmails/text"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Can Text"
                      src="../../assets/HexagonDesign/cells/can_text.png"
                      title="Candidates Text"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor r4 c8">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_1_2_6")
                      ? "/PartnerEmails/text"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Sub Text"
                      src="../../assets/HexagonDesign/cells/sub_text.png"
                      title="Subcontractors Text"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor r4 c9">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_2_2_6")
                      ? "/AgencyEmails/text"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Rec Text"
                      src="../../assets/HexagonDesign/cells/rec_text.png"
                      title="Recruiters Text"
                    />
                  </a>
                </div>
              </div>
              <div className="item monitor r4 c6">
                <div className="image">
                  <a
                    href={`${checkMenuPermission("ssm_5_5_6")
                      ? "/SurveyFeedback"
                      : "#access-denied"
                      }`}
                  >
                    <img
                      alt="Srv"
                      src="../../assets/HexagonDesign/cells/6_5.png"
                      title="Surveys"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentHexagon;
